// extracted by mini-css-extract-plugin
export default {"feedback-wrapper":"UserFeedback_feedback-wrapper__WmUMg","feedback-header":"UserFeedback_feedback-header__BWLwo","feedback-input":"UserFeedback_feedback-input__9uc3P"};